/**
 * Google Authentication Utility
 * Handles Google Sign-In using Google Identity Services
 * Extracts google_id (sub) from Google ID Token
 */

// Decode JWT token to extract payload
const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT:', error);
    throw new Error('Failed to decode Google ID token');
  }
};

/**
 * Extract google_id (sub) from Google ID token
 * @param {string} credential - Google ID token (JWT)
 * @returns {string} google_id (sub from token)
 */
export const extractGoogleId = (credential) => {
  try {
    const decoded = decodeJWT(credential);
    const googleId = decoded.sub;
    
    if (!googleId) {
      throw new Error('Google ID token does not contain sub field');
    }
    
    return googleId;
  } catch (error) {
    console.error('Error extracting Google ID:', error);
    throw error;
  }
};

/**
 * Extract user info from Google ID token
 * @param {string} credential - Google ID token (JWT)
 * @returns {object} User info (email, name, picture, etc.)
 */
export const extractGoogleUserInfo = (credential) => {
  try {
    const decoded = decodeJWT(credential);
    return {
      email: decoded.email,
      first_name: decoded.given_name || decoded.name?.split(' ')[0] || '',
      last_name: decoded.family_name || decoded.name?.split(' ').slice(1).join(' ') || '',
      picture: decoded.picture,
      google_id: decoded.sub,
    };
  } catch (error) {
    console.error('Error extracting Google user info:', error);
    throw error;
  }
};


